<template>
  <div class="boss">
    <div class="header" @click="goIndex">  
      <img src="../image/logo.png" alt="">
      <h3>Terms of Service</h3>
      </div>

    <h4>Terms of Service</h4>
   
 <h4>1. Introduction</h4> 
<p>Welcome to Final Boss Arena ("the Website"). By accessing or using our services, you agree to comply with and be bound by the following Terms of Service. Please read these terms carefully before using the Website. If you do not agree with any part of these terms, you must not use the Website.</p>
<h4>2. Acceptance of Terms</h4> 
<p>By accessing or using the services offered on Final Boss Arena, you confirm that you are at least 18 years old (or the age of majority in your jurisdiction) and agree to be legally bound by these Terms of Service. If you are using the Website on behalf of an organization, you represent that you have the authority to bind that organization to these Terms.</p>
<h4>3. Changes to Terms</h4> 
<p>Final Boss Arena reserves the right to modify or update these Terms of Service at any time without prior notice. Any changes will be posted on this page, and the date of the most recent update will be indicated at the bottom of the page. By continuing to use the Website after any changes are posted, you agree to the revised terms.</p>
<h4>4. Services Provided</h4> 
<p>Final Boss Arena provides consulting services in various areas, including but not limited to business strategy, digital marketing, and more. These services may be subject to additional terms and agreements, which will be provided at the time of consultation.</p>
<h4>5. User Responsibilities</h4> 
<p>You agree to use the Website and its services in a lawful and respectful manner. You are responsible for maintaining the confidentiality of any account information and passwords associated with your use of the Website. You also agree not to engage in any activity that could damage, disrupt, or interfere with the Website or its services.</p>
<h4>6. User Content</h4> 
<p>Any content, feedback, or materials that you submit to Final Boss Arena via the Website, including suggestions, ideas, or any other forms of communication, will be treated as non-confidential and may be used by us for any purpose, including but not limited to improving the services or creating new offerings.</p>
<h4>7. Privacy Policy</h4> 
<p>Your privacy is important to us. Please review our <a href="/privacy-policy">Privacy Policy</a>, which governs the collection and use of your information. By using the Website, you consent to the practices described in the Privacy Policy.</p>
<h4>8. Prohibited Activities</h4> 
<p>You may not use the Website for any illegal or prohibited activities, including but not limited to:</p> <ul> <li>Engaging in fraud or illegal activities</li> <li>Impersonating others</li> <li>Distributing harmful or malicious content</li> <li>Infringing on intellectual property rights</li> </ul>
<h4>9. Limitation of Liability</h4> 
<p>Final Boss Arena makes no warranties regarding the accuracy, reliability, or completeness of any content or services provided on the Website. To the fullest extent permitted by law, Final Boss Arena will not be liable for any indirect, incidental, special, or consequential damages arising from the use of the Website or its services.</p>
<h4>10. Governing Law</h4> 
<p>These Terms of Service are governed by the laws of the jurisdiction in which Final Boss Arena operates, without regard to its conflict of law principles. Any disputes related to these terms will be resolved in the courts of the relevant jurisdiction.</p>
<h4>11. Contact Us</h4> 
<p>If you have any questions or concerns about these Terms of Service, please contact us at:</p> <p>Email: support@finalbossarena.site</p> <p>Address: [Your Business Address]</p>
<h4>12. Last Updated</h4> 
<p>These Terms of Service were last updated on [Date].</p>
<p>    Email: <a href="mailto:asking@asking.media">asking@asking.media</a><br>
    Website: <a href="https://finalbossarena.site">https://finalbossarena.site</a></p>
    <div class="footer">
      <a @click="goprivacy">privacy</a>
      <a href="/">Home</a>
 </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
    };
  },

  methods: {
    goprivacy(){
      this.$router.push('/privacy')
    },
    goIndex() {

        // this.$router.replace({ path: "/" });
        window.location.href = "/"
   
    },

    golist() {

 
 window.location.href = "/#/list"
      
    },
  },
};
</script>

<style lang="less" scoped>
.footer{
    align-items: center;
    background: #d6d6d6;
    border-top: 1px solid var(--footer_border_color);
    display: flex;
    height: 40px;
    justify-content: space-around;
    left: 0;
    position: sticky;
    color: #000;
    width: 100%;
    max-width: 700px;
    z-index: 2;
    bottom: 0px;
}

 .footer a {
    color: rgb(8, 8, 8);
    text-decoration: none;
    font-weight: 700;
}
.boss{
    margin: auto;
    max-width: 700px;
        padding: 20px;
}
.header {
    height: 80px;
    display: flex;
      font-size: 1.6rem;
          box-shadow: 0 2px 24px 0 rgba(0, 0, 0, .25);
}
.header img{
  height: 100%;
}
.header h3{
    width: 68%;
    line-height: 80px;
    color: #679571;
    font-size: 20px;
    text-align: center;
    font-family: sans-serif;
}
p {

    text-align: start;
    padding: 10px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    background: #679571;
}
.el-icon-s-home{
       font-size: 3rem;
    color: #ffffff;
}
.el-icon-menu{
     font-size: 3rem;
  color: #ffffff;
}
.bottom-btn{
      background: #F1A645;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
a{
      color: #fff;
    font-size: 16px;
        text-decoration: none;
    font-weight: 600;
    padding: 4px;
}
h4 {
    color: white;
    background: #679571;
}
h4 {
  padding: 10px;
    color: white;

}
ul {
  padding: 10px;
  color: white;
    background: #679571;
    list-style-type: none;
    padding-left: 0; /* 如果需要去除左侧的缩进 */
  }
  ul li{
  padding: 10px;

  }
</style>
